import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import messages from '../../../../../intl/messages';
import { LabeledColumn } from '../../../../lab/TextGroup/LabeledColumn';

interface OwnProps {
  allocation: string | number;
}

interface AllocationColumnProps extends OwnProps, InjectedIntlProps {}

const AllocationColumnBase: FunctionComponent<AllocationColumnProps> = ({
  allocation,
  intl: { formatMessage },
}) => {
  return (
    <LabeledColumn
      label={formatMessage(messages.segmentContent.allocation)}
      mainText={allocation}
    />
  );
};

export const AllocationColumn = injectIntl(AllocationColumnBase);

AllocationColumn.displayName = 'AllocationColumn';
